// extracted by mini-css-extract-plugin
export default {"interactDomSkillHighlight":"interact-dom-module__interactDomSkillHighlight--nDwwz"};